import { ApiClient } from '@webapp/core/services/ApiClient'
import { MileageRatePresetRepository } from './MileageRatePresetRepository'

export const mileageRatePresetRepository = new MileageRatePresetRepository({
  httpClient: ApiClient,
})

export { MileageRatePresetRepository } from './MileageRatePresetRepository'
